const STORAGE_KEY = 'roadworld:playerName';

export function storedName(): string | null {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    if (!v) return null;
    const t = v.trim().slice(0, 20);
    return t.length === 0 ? null : t;
  } catch {
    return null;
  }
}

export function saveName(name: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, name.trim().slice(0, 20));
  } catch {
    // ignore — quota or disabled storage
  }
}

/**
 * Resolve the player's name. If one is cached, return it; otherwise show a small modal
 * and resolve once the user submits. Falls back to "Player" if the user dismisses.
 */
export async function resolvePlayerName(): Promise<string> {
  const cached = storedName();
  if (cached) return cached;
  const name = await promptForName();
  saveName(name);
  return name;
}

function promptForName(): Promise<string> {
  return new Promise((resolve) => {
    const overlay = document.createElement('div');
    overlay.className = 'mp-name-overlay';
    overlay.innerHTML = `
      <div class="mp-name-modal">
        <h2>Welcome to RoadWorld</h2>
        <p>Pick a name to show to other drivers.</p>
        <input type="text" id="mpNameInput" maxlength="20" placeholder="Your name" autofocus />
        <button id="mpNameBtn">Join</button>
      </div>
    `;
    document.body.appendChild(overlay);

    const input = overlay.querySelector('#mpNameInput') as HTMLInputElement;
    const btn = overlay.querySelector('#mpNameBtn') as HTMLButtonElement;

    const submit = () => {
      const trimmed = input.value.trim().slice(0, 20);
      if (trimmed.length === 0) {
        input.focus();
        return;
      }
      overlay.remove();
      resolve(trimmed);
    };
    btn.addEventListener('click', submit);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') submit();
    });
    setTimeout(() => input.focus(), 0);
  });
}
